<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<div class="two-column" [class.highlight]="highlight">
	<mat-card class="left-side-card clickable highlightable" (click)="onClick()">
		<mat-card-header class="single-list-item list-item-header">
			<!-- avatar section -->
			<mat-icon
				mat-card-avatar
				class="item-color-avatar column-center list-item-icon"
				[ngClass]="{ 'large-icon': this.itemData.leftLogo.type === 'color' }"
				[ngStyle]="{
					background: this.itemData.leftLogo.type === 'color' ? this.itemData.leftLogo.value : 'unset',
					color:
						this.itemData.leftLogo.type === 'icon'
							? this.itemData.leftLogo.color
								? this.itemData.leftLogo.color
								: 'var(--touchplan-blue-dark)'
							: 'unset'
				}"
			>
				{{ this.itemData.leftLogo.type === 'icon' ? this.itemData.leftLogo.value : '' }}
			</mat-icon>

			<!-- main section -->
			<!-- Workaround to get required custom fields to display a visual indicator -->
			<!-- Possible "better" solution: modify the middleContent property from the IListItemData to support custom classes or something similar -->
			<!-- currently is just an array of strings. -->
			<mat-card-title
				*ngIf="this.itemData.middleContent && this.itemData.middleContent.length > 0"
				class="h3-heading-regular break-long-words list-item-title"
				[ngClass]="{
					required: item?.view?.isRequired
				}"
			>
				{{ this.itemData.middleContent[0] }}
			</mat-card-title>
			<mat-card-subtitle
				*ngFor="let description of this.itemData.middleContent | slice : 1"
				class="list-item-subtitle"
			>
				{{ description }}
			</mat-card-subtitle>
		</mat-card-header>
	</mat-card>

	<div
		*ngIf="itemData.rightSummary"
		class="h4-heading-regular"
		[ngClass]="{
			'right-side-card': itemData.rightSummary.type === 'text',
			'right-side-icon': itemData.rightSummary.type === 'icon'
		}"
	>
		<span *ngIf="itemData.rightSummary.type === 'text'">{{ itemData.rightSummary.value }}</span>
		<mat-icon
			*ngIf="
				itemData.rightSummary.type === 'icon' &&
				(dragAndDropEnabled || itemData.rightSummary.value !== 'drag_handle')
			"
			class="column-center"
			automationId="dragHandle"
			[ngClass]="{ draggable: dragAndDropEnabled && itemData.rightSummary.value === 'drag_handle' }"
		>
			{{ itemData.rightSummary.value }}
		</mat-icon>
	</div>
</div>
